
const Navigo = require('../90_utils/Navigo');

let instance = null; // singleton

class Router {

	constructor(el, params){

		if(!instance){
			instance = this;
			this._init();
		}

		return instance;
	}

	_init(){

		// vars

		this.routeObj;
		this.isSilent;
		this.isPending;

		// config router

		this._config();
		this._firstPage();
	}

	_config(){

		this.router = new Navigo(window.SETTINGS.paths.root);

		let processRoute = (pageId, params) => {
			console.log('processRoute', pageId, params, 'silent?', this.isSilent);
			if(!this.isSilent){
				let sectionId = params ? this._validateSubsection(pageId, params.subsection) : '';
				this._triggerContentChange(pageId, sectionId);
			}
			this.isSilent = false;
		}

		this.router.on({

			'intro/*': (params) => { processRoute('intro', null); },
			'intro': (params) => { processRoute('intro', null); },

			'home/*': (params) => { processRoute('intro', null); },
			'home': (params) => { processRoute('intro', null); },

			'vision/:subsection': (params) => { processRoute('vision', params); },
			'vision/:subsection/*': (params) => { processRoute('vision', params); },
			'vision': (params) => { processRoute('vision', params); },

			'action/:subsection': (params) => { processRoute('action', params); },
			'action/:subsection/*': (params) => { processRoute('action', params); },
			'action': (params) => { processRoute('action', params); },

			'impact/:subsection': (params) => { processRoute('impact', params); },
			'impact/:subsection/*': (params) => { processRoute('impact', params); },
			'impact': (params) => { processRoute('impact', params); }

		}).resolve();

		this.router.notFound((query) => {
			this._triggerContentChange('intro');
		});

		this._addListeners();
	}

	_firstPage(){
		let route = this.getRoute() || 'intro';
		this._navigateTo(route);
	}

	// listeners -------------------------------------------------------------------------------  /

	_addListeners(){
		window.vent.on('changeRoute', this._onChangeRoute, this);
		window.vent.on('silentRoute', this._onSilentRoute, this);
		window.vent.on('domUpdate', this._onLinkScan, this);
	}

	// listener methods

	_onChangeRoute(e, params){
		if(params && params.route && this.getRoute() !== this._cleanRoute(params.route)){
			this._navigateTo(params.route);
		}
	}

	_onSilentRoute(e, params){
		if(params && params.route && this.getRoute() !== this._cleanRoute(params.route)){
			this._navigateTo(params.route, true);
		}
	}

	_onLinkScan(e){

		let $a = $('a');
		$a.off('click', $.proxy(this._onLinkClick, this));
		$a.on('click', $.proxy(this._onLinkClick, this));

		$('a[target="_blank"]').attr('title', 'This link will open a new window or tab depending on your browser settings.');
		$a.addClass('linked');
	}

	_onLinkClick(e){

		let $target = $(e.currentTarget);
		let href = this._cleanRoute($target.attr('href'));
		let hrefObj = href.split('/');
		let target = $target.attr('target');

		if(href && href !== 'javascript:;' && target !== '_blank' && !this.isPending){

			let route = this.getRoute();
			let routeObj = this.getRouteObj();

			if($('body').hasClass('page-loaded')){

				let delay = 0;
				let modalCloseDelay = 0;

				this.isPending = true;

				if($('.modaal-wrapper').length){

					// let modal close before content changes

					delay = 400;

					if(window.SETTINGS.breakpoint.maxWidth('screen-medium', true)){
						delay = 600;
						modalCloseDelay = 300;
					}

					window.setTimeout(() => {
						window.vent.trigger('closeModal');
					}, modalCloseDelay);
				}

				window.setTimeout(() => {

					this.isPending = false;

					if(href === route || (hrefObj[0] === routeObj.pageId && !hrefObj[1] && !routeObj.sectionId)){
						window.vent.trigger('silentRoute', {route: href});
					} else {
						window.vent.trigger('linkChangeRoute', {route:$target.attr('href')});
						window.vent.trigger('changeRoute', {route: href});
					}
				}, delay);
			}
			e.preventDefault();
		}
	}

	// primary methods -------------------------------------------------------------------------  /

	// change page URL (will trigger content change through router)

	_navigateTo(newRoute, isSilent){
		this.isSilent = (isSilent === true);
		this.router.navigate(this._cleanRoute(newRoute));
	}

	// change page content (render changes on dom)

	_triggerContentChange(pageId, sectionId){

		let newRoute = this._cleanRoute(this._cleanRoute(pageId) + '/' + this._cleanRoute(sectionId));

		if(!this.routeObj || this.routeObj.route !== newRoute){

			sectionId = sectionId ? sectionId : null;

			let route = {
				pageId: pageId,
				sectionId: sectionId,
				route: newRoute
			}

			this.routeObj = route;

			window.vent.trigger('changePageContent', {id:pageId, sectionId:sectionId});
		}
	}

	// utils -----------------------------------------------------------------------------------  /

	// remove extra slashes from route, format for comparison and router.navigate

	_cleanRoute(newRoute){

		if(newRoute){

			newRoute = newRoute.replace(/\/+$/, '') + '/';

			let splitRoute = (route) => {
				if(route.charAt(0) === '/'){ route = route.substr(1); }
				if(route.charAt(route.length-1) === '/'){ route = route.substr(0, route.length-1); }
				return route.split('/');
			}

			return splitRoute(newRoute).join('/');
		}

		return '';
	}

	_validateSubsection(pageId, sectionId){

		if(pageId && sectionId){
			let pageObj = window.SETTINGS.pageSections[pageId].sections;
			if(pageObj){
				let result = _.findWhere(pageObj, {id: sectionId});
				if(result){ return sectionId; }
			}
		}
		return '';
	}

	// getters ---------------------------------------------------------------------------------  /

	getRoute(){
		return this.getRouteObj().route;
	}

	getRouteObj(){
		return Object.assign({}, this.routeObj);
	}

	getParams(){
		return this.router.getParams();
	}
}

module.exports = Router;
